import { Box, Button, Modal, Typography } from '@mui/material'
import { useStyles } from './styles'

interface IRemovePermissionModal {
  openModal: boolean
  setOpenModal: (id: string) => void
  id: string
  removePermission: (id: string) => void
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 520,
  Height: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  overflow: 'hidden',
  padding: '1.5rem',
}

const RemovePermissionModal = ({ openModal, setOpenModal, id, removePermission }: IRemovePermissionModal) => {
  const classes = useStyles()

  return (
    <Modal
      open={openModal}
      onClose={setOpenModal}
    >
      <Box sx={style}>
        <Typography className={classes.title}>Remover permissão</Typography>

        <Box className={classes.descriptionBox}>
          <Typography className={classes.description}>
            Deseja remover a permissão da tabela selecionada? Esta ação impede a sincronização desta tabela com o cofre
            digital, impossibilitando o uso de automações
          </Typography>

          <Box className={classes.buttonContainer}>
            <Button
              variant='text'
              color='primary'
              onClick={() => setOpenModal(id)}
            >
              Continuar com a permissão
            </Button>
            <Button
              variant='contained'
              sx={{
                backgroundColor: 'red',
              }}
              className={classes.buttonRemoval}
              onClick={() => {
                removePermission(id)
                setOpenModal(id)
              }}
            >
              Remover permissão
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default RemovePermissionModal
